// Full-size photography linked to specific menu items. Photographed dishes
// become large editorial "features"; everything else renders as a quiet list.
// Keyed by a normalized item name so lookups survive casing/punctuation.

import angelHair from "food_pictures/menu/angel-hair.jpg";
import asiagoGnocchi from "food_pictures/menu/asiago-stuffed-gnocchi.jpg";
import goatCheese from "food_pictures/menu/baked-goat-cheese.jpg";
import calamari from "food_pictures/menu/calamari.jpg";
import caprese from "food_pictures/menu/insalata-caprese.jpg";
import cioppino from "food_pictures/menu/cioppino.jpg";
import hazelnutTart from "food_pictures/menu/hazelnut-pear-tart.jpg";
import lambShank from "food_pictures/menu/lamb-shank.jpg";
import moltenCake from "food_pictures/menu/molten-chocolate-cake.jpg";
import rigatoniPrimavera from "food_pictures/menu/rigatoni-primavera.jpg";
import pappardelle from "food_pictures/menu/pappardelle.jpg";
import bakedRigatoni from "food_pictures/menu/baked-rigatoni.jpg";
import zitiPrimavera from "food_pictures/menu/ziti-primavera.jpg";
import florentine from "food_pictures/menu/florentine.jpg";
import walnutGorgonzola from "food_pictures/menu/walnut-gorgonzola.jpg";
import meatballs from "food_pictures/menu/meatballs.jpg";
import stripSteak from "food_pictures/menu/grilled-new-york-strip-steak.jpg";
import petiteChicken from "food_pictures/menu/organic-petite-chicken.jpg";
import tiramisu from "food_pictures/menu/tiramisu.jpg";
import bruschetta from "food_pictures/menu/bruschetta.jpg";
import mussels from "food_pictures/menu/mussels.jpg";
import octopus from "food_pictures/menu/grilled-octopus.jpg";
import mixedGreens from "food_pictures/menu/mixed-greens.jpg";
import conchiglietti from "food_pictures/menu/conchiglietti.jpg";
import farfalleChicken from "food_pictures/menu/farfalle-with-chicken.jpg";
import spinachGnocchi from "food_pictures/menu/homemade-spinach-gnocchi.jpg";
import linguineMarinara from "food_pictures/menu/linguine-marinara.jpg";
import linguineClams from "food_pictures/menu/linguine-with-clams-and-mussels.jpg";
import tortellini from "food_pictures/menu/tortellini-della-nonna.jpg";
import salmon from "food_pictures/menu/grilled-salmon.jpg";
import cremeBrulee from "food_pictures/menu/limoncello-creme-brulee.jpg";
import demiPizza from "food_pictures/menu/demi.jpg";
import genoaPizza from "food_pictures/menu/genoa.jpg";

// keys are normalizeItemName(<menu item name>)
const byKey = {
  "angel hair": angelHair,
  "asiago stuffed gnocchi": asiagoGnocchi,
  "baked goat cheese": goatCheese,
  "calamari": calamari,
  "insalata caprese": caprese,
  "cioppino": cioppino,
  "hazelnut pear tart": hazelnutTart,
  "lamb shank": lambShank,
  "molten chocolate cake": moltenCake,
  "rigatoni primavera": rigatoniPrimavera,
  "pappardelle": pappardelle,
  "baked rigatoni": bakedRigatoni,
  "penne primavera": zitiPrimavera, // photographed with ziti
  "florentine": florentine,
  "walnut gorgonzola": walnutGorgonzola,
  "meatballs": meatballs,
  "grilled new york strip steak": stripSteak,
  "organic petite chicken": petiteChicken,
  "tiramisu": tiramisu,
  "bruschetta": bruschetta,
  "mussels": mussels,
  "grilled octopus": octopus,
  "mixed greens": mixedGreens,
  "conchiglietti": conchiglietti,
  "farfalle with chicken": farfalleChicken,
  "homemade spinach gnocchi": spinachGnocchi,
  "linguine marinara": linguineMarinara,
  "linguini marinara": linguineMarinara, // lunch menu spelling
  "linguine with clams and mussels": linguineClams,
  "tortellini della nonna": tortellini,
  "grilled salmon": salmon,
  "limoncello creme brulee": cremeBrulee,
  "demi": demiPizza,
  "genoa": genoaPizza,
};

// Optional object-position overrides for photos whose subject isn't centered
// (e.g. a portrait shot where the dish sits low in the frame).
const focalByKey = {};

export function normalizeItemName(name) {
  return String(name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // "LIMÓNCELLO CRÉME" -> "limoncello creme"
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

// Returns the image URL for an item name, or null if it has no photo yet.
export function imageForItem(name) {
  return byKey[normalizeItemName(name)] || null;
}

// Returns a CSS object-position for an item's photo, or undefined for default.
export function imageFocalForItem(name) {
  return focalByKey[normalizeItemName(name)] || undefined;
}
